
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ChecklistNodiGrid extends Serenity.EntityGrid<ChecklistNodiRow, any> {
        protected getColumnsKey() { return ChecklistNodiColumns.columnsKey; }
        protected getDialogType() { return ChecklistNodiDialog; }
        protected getIdProperty() { return ChecklistNodiRow.idProperty; }
        protected getInsertPermission() { return ChecklistNodiRow.insertPermission; }
        protected getLocalTextPrefix() { return ChecklistNodiRow.localTextPrefix; }
        protected getService() { return ChecklistNodiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}